import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HistoryIcon from "@mui/icons-material/History";

const NursinghomeHomePage = () => {
  const navigate = useNavigate();

  // Get welcome message based on time of day
  const getWelcomeMessage = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return "בוקר טוב";
    } else if (hour < 18) {
      return "צהריים טובים";
    } else {
      return "ערב טוב";
    }
  };

  const handleNavigate = () => {
    navigate("/nursinghome");
  };

  const handleNavigateToHistory = () => {
    navigate("/nursinghome/history");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100%",
        flex: 1,
        backgroundColor: "#f5f7fa",
        padding: { xs: 2, md: 4 },
      }}
    >
      <Card
        sx={{
          maxWidth: 600,
          width: "100%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <CardContent
          sx={{
            padding: { xs: 3, md: 5 },
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#e3f2fd",
                borderRadius: "50%",
                padding: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <HomeWorkIcon
                sx={{
                  fontSize: 80,
                  color: "#1976d2",
                }}
              />
            </Box>
          </Box>

          {/* Welcome Message */}
          <Typography
            variant="h4"
            sx={{
              fontFamily: "'Varela Round', sans-serif",
              fontWeight: 600,
              color: "#1a237e",
              marginBottom: 1,
            }}
          >
            {getWelcomeMessage()}
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontFamily: "'Varela Round', sans-serif",
              color: "#424242",
              marginBottom: 4,
            }}
          >
            ברוכים הבאים לפורטל בית אבות
          </Typography>

          {/* Main Button */}
          <Button
            variant="contained"
            size="large"
            onClick={handleNavigate}
            startIcon={<LocalHospitalIcon />}
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              fontSize: "1.2rem",
              padding: "12px 40px",
              borderRadius: 2,
              textTransform: "none",
              fontFamily: "'Varela Round', sans-serif",
              boxShadow: "0 4px 12px rgba(25,118,210,0.3)",
              "&:hover": {
                backgroundColor: "#1565c0",
                boxShadow: "0 6px 16px rgba(25,118,210,0.4)",
              },
            }}
          >
            הזמנה חדשה
          </Button>

          {/* Order History Button */}
          <Box sx={{ marginTop: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={handleNavigateToHistory}
              startIcon={<HistoryIcon />}
              sx={{
                color: "#1976d2",
                borderColor: "#1976d2",
                fontSize: "1rem",
                padding: "10px 32px",
                borderRadius: 2,
                textTransform: "none",
                fontFamily: "'Varela Round', sans-serif",
                "&:hover": {
                  borderColor: "#1565c0",
                  backgroundColor: "rgba(25,118,210,0.04)",
                },
              }}
            >
              היסטוריית הזמנות
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NursinghomeHomePage;
